import { compareAsc, compareDesc } from "date-fns";
import { cloneDeep } from "lodash";
import PaymentDto from "../../PaymentContainerClient/dtos/PaymentDto";

export enum PaymentCreatedAtSortDirection {
    Asc = "ASC",
    Desc = "DESC",
}

export default function getPaymentsSortedByCreatedAt(
    payments?: PaymentDto[],
    sortDirection: PaymentCreatedAtSortDirection = PaymentCreatedAtSortDirection.Asc
): PaymentDto[] {
    return payments
        ? cloneDeep(payments).sort((paymentA, paymentB) =>
              sortDirection === PaymentCreatedAtSortDirection.Asc
                  ? compareAsc(
                        new Date(paymentA.createdAt),
                        new Date(paymentB.createdAt)
                    )
                  : compareDesc(
                        new Date(paymentA.createdAt),
                        new Date(paymentB.createdAt)
                    )
          )
        : [];
}
